/* 電子契約の希望のラジオボタン */
import React from 'react';
import { InputGroup } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import { KeyValue } from '../types/KeyValue';
import Messages from '../molecules/Messages';
import Paragraph from './Paragraph';
import { use_large_label } from '../const/RadioButton';

interface Props {
  id: string;
  css_class?: string;
  label: string;
  need?: boolean;
  sources: Array<KeyValue>;
  name: string;
  value: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  message?: string;
  help_msg?: string;
  disabled: boolean;
  handleBlur?: VoidFunction;
  looks_inactive?: boolean;
  readonly?: boolean;
}

const RadioDesiredEcontract: React.FC<Props> = ({
  id,
  css_class,
  label,
  need,
  sources,
  name,
  value,
  handleChange,
  message,
  help_msg,
  disabled,
  handleBlur,
  looks_inactive,
  readonly,
}) => {
  /**
   * 通常のラジオボタンを描画する
   * @return JSX.Element ラジオボタンのElement
   */
  const returnRadioButtonJsx = () => {
    return (
      <>
        <InputGroup>
          {sources.map((src, index) => {
            return (
              <label
                className={`radio-label ${src.value.length >= use_large_label &&
                  'radio-label-large'}`}
                key={src.key}
              >
                <input
                  id={`${id}-${index}`}
                  type="radio"
                  value={src.key}
                  name={name}
                  checked={src.key === value}
                  onChange={handleChange}
                  disabled={disabled || readonly}
                  onBlur={handleBlur}
                  className="input-radio"
                />
                <span className={message ? 'radio-icon_valid' : 'radio-icon'}></span>
                {src.value}
              </label>
            );
          })}
        </InputGroup>
        <Messages help_msg={help_msg} valid_msg={message} />
      </>
    );
  };

  /**
   * ラベルを描画する
   * @return JSX.Element ラベルのElement
   */
  const returnLabelJsx = () => {
    return <>{sources.map(src => src.key === value && <Paragraph key={id} label={src.value} />)}</>;
  };

  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      looks_inactive={looks_inactive}
      content={
        <div className={`p-radio ${css_class ?? ''}`}>
          {disabled || looks_inactive ? returnLabelJsx() : returnRadioButtonJsx()}
        </div>
      }
    />
  );
};

export default RadioDesiredEcontract;
